const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const html2canvas = require("html2canvas");
const _ = require("lodash");
const ErrorUtil = require("../../../shared/ErrorUtil");

const AT = require("../vault/ActionTypes");
const {
	atPage,
	atUser,
	atCurrBlock,
	atCurrLabBlock,
	atCurrResult,
} = require("../vault/StateCursors");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const withContainerDims = require("../hoc/withContainerDims");

const {Portal} = require("./Portal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const BugReportModal = require("./BugReportModal");
const BugReportArrow = require("./BugReportArrow");
const BugReportUtil = require("../util/BugReportUtil");
const TempCanvas = require("../util/TempCanvas");
const CanvasUtil = require("../util/CanvasUtil");
const ContainerSize = require("../util/ContainerSize");
const {ASPECT_RATIO} = ContainerSize;
const OpsPage = require("../vault/OpsPage");

const CopyTable = require("../util/CopyTable");
const BugCopy = CopyTable.forBugReport();
const styles = require("./styles/BugReport.css");

const SCREENSHOT_HEIGHT = 450;
const INDICATOR_TIMEOUT = 2000; // milliseconds to show the indicator after submission
const STEPS = ["option", "input", "arrow", "message"];

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withContainerDims(Component);
	Component = withVaultUpdate(Component, (props, vaultState) => ({
		page: atPage(vaultState).get(),
		user: atUser(vaultState).get(),
		block: atCurrBlock(vaultState).get(),
		labBlock: atCurrLabBlock(vaultState).get(),
		result: atCurrResult(vaultState).get(),
		connected: vaultState.connected,
	}));
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "BugReport",

		propTypes: {
			// Injected by HOCs
			connected: PT.bool.isRequired,
			page: PT.object,
			user: PT.object,
			block: PT.object,
			labBlock: PT.object,
			result: PT.object,
			dispatch: PT.func.isRequired,
			containerDims: PT.shape({
				width: PT.number.isRequired,
				height: PT.number.isRequired,
				windowWidth: PT.number.isRequired,
				windowHeight: PT.number.isRequired,
			}).isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			reportBug: function() {
				this.pickModal();
			},
			resetVaultState: function() {
				this.setState({modalShown: false});
			},
			bugReportSuccess: function() {
				this.setState({
					submitting: false,
					submitted: true,
					lastSubmitted: Date.now(),
				});
				setTimeout(() => this.forceUpdate(), INDICATOR_TIMEOUT);
			},
			bugReportFail: function() {
				this.setState({
					submitting: false,
					modalShown: false,
					step: "option",
				});
			},
		},

		getInitialState: function() {
			return {
				//Normal report bug modal flow
				modalShown: false,
				//Show confirm send bug report (for same problem)
				confirmNewBugModal: false,
				//Prevent new bug report submissions for >3 bug reports for same problem
				blockBugReportModal: false,
				step: "option", // "option" -> "input" -> "arrow" -> "message"
				reason: "",
				description: "",
				submitted: false,
				submitting: false,
				taskSent: false,
				taskURL: false,
				lastSubmitted: 0,
			};
		},

		UNSAFE_componentWillReceiveProps: function(nextProps) {
			if (nextProps.user.userID !== this.props.user.userID) {
				this.setState(this.getInitialState());
			}
		},

		submitModal: function() {
			this.props.dispatch({
				type: AT.UPDATE_BUG_SUBMITTING,
				data: {submitting: true},
			});
			this.setState({
				submitting: true,
			});

			const inputData = _.pick(this.state, ["reason", "description"]);
			const bugReportData = BugReportUtil.generateBugReportData(
				inputData,
				this.props
			);

			setTimeout(() => {
				html2canvas(document.getElementById("MainTrainerContent"), {}).then(
					canvas => {
						let screenshot;
						const {height} = this.props.containerDims;
						try {
							if (height > SCREENSHOT_HEIGHT) {
								const tempCanvas = TempCanvas.requestCanvas(
									SCREENSHOT_HEIGHT * ASPECT_RATIO,
									SCREENSHOT_HEIGHT
								);
								const tempCtx = tempCanvas.getContext("2d");
								// Undo DPR scaling by requestCanvas
								CanvasUtil.setCanvasScaleTransform(tempCtx, 1);
								tempCtx.drawImage(
									canvas,
									0,
									0,
									SCREENSHOT_HEIGHT * ASPECT_RATIO,
									SCREENSHOT_HEIGHT
								);
								screenshot = tempCanvas.toDataURL();
								TempCanvas.releaseCanvas(tempCanvas);
							} else {
								screenshot = canvas.toDataURL();
							}
						} catch (ex) {
							ErrorUtil.log("E_BAD_SCREENSHOT", ex);
						}
						this.setState({
							step: "message",
						});
						bugReportData.screenshot = screenshot;
						this.finishReport(bugReportData);
					}
				);
			}, 0);
		},

		finishReport: function(data) {
			const payload = {
				reporter: data.reporter,
				title: data.reportTitle,
				desc: data.reportBody,
				baBlocks: data.baBlocks,
				baDev: data.baDev,
				baNeverland: data.baNeverland,
				blockID: data.blockID,
				labBlockID: data.labBlockID,
				screenshot: data.screenshot,
				type: data.type,
				soundsLog: data.soundsLog,
				userReason: data.userReason,
				userDescription: data.userDescription,
			};
			this.props.dispatch({
				type: AT.SEND_BUG_REPORT_REQUEST,
				payload,
			});
		},

		closeArrow: function() {
			this.setState({
				modalShown: false,
				step: "option",
			});
			this.props.dispatch({
				type: AT.CLOSE_MODAL_IN_THEATER,
			});
		},

		closeModal: function() {
			this.setState({
				modalShown: false,
				confirmNewBugModal: false,
				blockBugReportModal: false,
				step: "option",
			});
			this.props.dispatch({
				type: AT.CLOSE_MODAL_IN_THEATER,
			});
		},

		makeIndicator: function(status) {
			if (!status) return null;
			let copy = "";
			let className;
			if (status === "pending") {
				className = styles.indPending;
				copy = BugCopy.submittingBug;
			}
			if (status === "success") {
				className = styles.indSuccess;
				copy = BugCopy.submittedBug;
			}
			return (
				<Portal container={PORTAL_CONTAINERS.BUG_REPORT_STATUS_INDICATOR}>
					<div className={styles.indicator}>
						<div className={className}>{copy}</div>
					</div>
				</Portal>
			);
		},

		goToNextStep: function(data) {
			const currStep = this.state.step;
			const newState = {};
			if (currStep === "option") {
				newState.reason = data;
				newState.step = STEPS[STEPS.indexOf(currStep) + 1];
			} else if (currStep === "input") {
				newState.description = data;
				newState.step = STEPS[STEPS.indexOf(currStep) + 1];
			} else if (currStep === "arrow") {
				this.submitModal();
			}
			return this.setState(newState);
		},

		renderModal: function() {
			const {step, submitting} = this.state;
			const {page} = this.props;
			const shouldShowReadAloud = OpsPage.shouldShowReadAloud(page);
			const options = CopyTable.getBugReportOptions(
				page.name,
				shouldShowReadAloud
			);

			if (step === "message") {
				return (
					<BugReportModal
						step="message"
						messageType={"success"}
						onClose={this.closeModal}
						buttons={[
							{
								buttonType: "ok",
								handleClick: this.closeModal,
							},
						]}
					/>
				);
			} else if (step === "arrow") {
				return (
					<BugReportArrow
						onClose={this.closeArrow}
						onSubmit={this.goToNextStep}
						isSubmitting={submitting}
					/>
				);
			} else if (step === "option") {
				if (submitting) {
					return null;
				} else {
					return (
						<BugReportModal
							step="buttonBody"
							options={_.keys(options)}
							onClose={this.closeModal}
							buttons={[
								{
									buttonType: "continue",
									handleClick: opt => this.goToNextStep(opt),
								},
							]}
						/>
					);
				}
			} else if (step === "input") {
				return (
					<BugReportModal
						step="inputBody"
						onClose={this.closeModal}
						buttons={[
							{
								buttonType: "submit",
								handleClick: desc => this.goToNextStep(desc),
							},
						]}
					/>
				);
			}
		},

		pickModal: function() {
			const {result} = this.props;
			const bugReports = _.get(
				result,
				["problems", result && result.currentProblemIndex, "bugReports"],
				[]
			);
			const bugReportsSubmitted = bugReports.length;
			const newState = {
				modalShown: false,
				confirmNewBugModal: false,
				blockBugReportModal: false,
				submitted: false,
				submitting: false,
			};
			if (!bugReportsSubmitted) {
				newState.modalShown = true;
			} else if (bugReportsSubmitted < 2) {
				newState.confirmNewBugModal = true;
			} else if (bugReportsSubmitted >= 2) {
				newState.blockBugReportModal = true;
			}

			this.setState(newState);
		},

		openReportModal: function() {
			this.setState({modalShown: true});
		},

		render: function() {
			let modal = null;

			// Only show option if no previous bug reports for this particular
			// problem. Else, prompt for if they really want to submit bug report
			// again for same problem.
			if (this.state.modalShown) {
				modal = this.renderModal();
			} else if (this.state.confirmNewBugModal) {
				modal = (
					<BugReportModal
						step="message"
						messageType="repeatSubmitProblem"
						onClose={this.closeModal}
						buttons={[
							{
								buttonType: "yes",
								handleClick: this.openReportModal,
							},
							{
								buttonType: "cancel",
								handleClick: this.closeModal,
							},
						]}
					/>
				);
			} else if (this.state.blockBugReportModal) {
				modal = (
					<BugReportModal
						step="message"
						messageType="blockSubmitBug"
						onClose={this.closeModal}
						buttons={[
							{
								buttonType: "ok",
								handleClick: this.closeModal,
							},
						]}
					/>
				);
			}

			let indicator = null;
			// For all bug reports while submitting,
			// show the 'Submitting bug report...' indicator
			if (this.state.submitting) {
				indicator = this.makeIndicator("pending");
			} else if (
				this.state.submitted &&
				Date.now() - this.state.lastSubmitted <= INDICATOR_TIMEOUT
			) {
				indicator = this.makeIndicator("success");
			}

			return (
				<div>
					{modal}
					{indicator}
				</div>
			);
		},
	})
);
